// extracted by mini-css-extract-plugin
export default {"root":"RegenerateToggle_root__F0DwX"};